import { observer } from "mobx-react";
import { portalStore } from "../../../../Stores/portal";
import { Container, Row } from "react-bootstrap";
import { useRef, useState } from "react";
import axios from "axios";

const _AccountingSettings: React.FC<{}> = () => {
  const headerRef = useRef(null);

  return (
    <Container
      fluid={true}
      style={{
        height: portalStore.portalHeight,
        background: "tomato",
      }}
    >
      <div ref={headerRef}>
        <h1 style={{ fontWeight: "bolder" }}>Accounting Settings</h1>
        <label>
          Make changes to your subscription plan and/or change the bank charged
        </label>
      </div>
      <Row>
        <SubscriptionCheckout
          planAmount={200.0}
          planName="Testing"
          userId="gibberish"
        />
      </Row>
    </Container>
  );
};

interface CheckoutProps {
  userId: string;
  planAmount: number;
  planName: string;
}

export default function SubscriptionCheckout({
  userId,
  planAmount,
  planName,
}: CheckoutProps) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubscribe = async () => {
    setLoading(true);
    setError(null);

    try {
      // 1. Request a checkout session from your Node.js backend
      const response = await axios.post("/api/create-subscription-checkout", {
        userId,
        amount: planAmount,
        currency: "ZAR", // Adjust to your currency
      });

      const { redirectUrl } = response.data;

      // 2. Redirect user to Peach Payments secure payment page
      // (or initialize their Web SDK / Embedded UI here)
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        throw new Error("Failed to retrieve payment gateway URL.");
      }
    } catch (err: any) {
      console.error("Subscription error:", err);
      setError(
        err.response?.data?.error || "Something went wrong. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        maxWidth: "400px",
        margin: "0 auto",
        padding: "20px",
        border: "1px solid #eaeaea",
        borderRadius: "8px",
      }}
    >
      <h2>Subscribe to {planName}</h2>
      <p>Amount: R {planAmount.toFixed(2)} / month</p>

      {error && (
        <div style={{ color: "red", marginBottom: "15px" }}>{error}</div>
      )}

      <button
        onClick={handleSubscribe}
        disabled={loading}
        style={{
          width: "100%",
          padding: "12px",
          backgroundColor: "#0070f3",
          color: "white",
          border: "none",
          borderRadius: "4px",
          fontSize: "16px",
          cursor: loading ? "not-allowed" : "pointer",
        }}
      >
        {loading ? "Processing..." : "Proceed to Secure Checkout"}
      </button>

      <p
        style={{
          fontSize: "12px",
          color: "#666",
          marginTop: "10px",
          textAlign: "center",
        }}
      >
        🔒 Secured by Peach Payments. Card details are tokenized safely.
      </p>
    </div>
  );
}

const AccountingSettings = observer(_AccountingSettings);
export { AccountingSettings };
